import Icon from '@katalon-studio/katalon-ui/Icon';
import React from 'react';
import colors from '../../../scss/colors.scss';

function TrashIcon(props) {
  const { color, textSize, type } = props;
  return <Icon
    type={`fa-${type}`}
    name="fa-trash"
    textSize={textSize}
    sx={{
      color,
    }}
    boundingSize={null}
    color={null}
  />;
}

TrashIcon.defaultProps = {
  color: colors.gray9,
  textSize: '14px',
  type: 'regular',
};

export default TrashIcon;
